import { render, staticRenderFns } from "./auto-message-search-messages.vue?vue&type=template&id=298aa9ef&scoped=true&"
import script from "./auto-message-search-messages.vue?vue&type=script&lang=js&"
export * from "./auto-message-search-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298aa9ef",
  null
  
)

export default component.exports